import { render, staticRenderFns } from "./MinecraftSearch.vue?vue&type=template&id=1bf3bf66&"
import script from "./MinecraftSearch.vue?vue&type=script&lang=js&"
export * from "./MinecraftSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports